import axios from "axios";
import jwt_decode from "jwt-decode";
import { BASE_BACKEND_URL, DATA_RETRIEVAL_BASE_URL } from "../constants";
import { tokenRefreshThunk } from "../features/user/userThunks";

export const checkToken = (access_token) => {
  if (access_token) {
    try {
      return jwt_decode(access_token).exp > Date.now().valueOf() / 1000;
    } catch (err) {
      return false;
    }
  }
  return false;
};

export class ApiClient {
  constructor({ baseURL, store = undefined, headers = {} } = {}) {
    this.baseURL = baseURL;
    this.store = store;
    this.headers = headers;

    this.http = axios.create({ baseURL: this.baseURL });

    if (this.store) {
      this.http.interceptors.request.use(
        async (config) => {
          const userState = this.store?.getState?.().user;
          if (!checkToken(userState?.token_access)) {
            await this.store?.dispatch?.(tokenRefreshThunk());
          }

          config.headers = {
            ...(config.headers || {}),
            authorization: `Bearer ${this.store?.getState?.()?.user?.token_access}`,
            ...this.headers,
          };

          return config;
        },
        (error) => Promise.reject(error)
      );
    } else if (Object.keys(this.headers).length > 0) {
      this.http.interceptors.request.use(
        (config) => {
          config.headers = { ...(config.headers || {}), ...this.headers };
          return config;
        },
        (error) => Promise.reject(error)
      );
    }
  }

  static public(headers = {}) {
    return new ApiClient({ baseURL: BASE_BACKEND_URL, headers });
  }

  static private(store, headers = {}) {
    return new ApiClient({ baseURL: BASE_BACKEND_URL, store, headers });
  }

  static dataRetrieval(store, headers = {}) {
    return new ApiClient({ baseURL: DATA_RETRIEVAL_BASE_URL, store, headers });
  }

  request(config) {
    return this.http.request(config);
  }

  get(url, config) {
    return this.http.get(url, config);
  }

  delete(url, config) {
    return this.http.delete(url, config);
  }

  post(url, data, config) {
    return this.http.post(url, data, config);
  }

  put(url, data, config) {
    return this.http.put(url, data, config);
  }

  patch(url, data, config) {
    return this.http.patch(url, data, config);
  }
}
